<template>
  <div slot="body">
    <bita-form ref="form">
      <div slot="body">
        <div class="row">
          <bita-input
            type="text"
            name="name"
            label="نام محصول"
            rules="required"
            :validation-container-class="largeColWidth"
            input-class="form-control"
            v-model="form.name"
          />
          <bita-input
            type="text"
            name="second_name"
            label="نام دوم محصول"
            subtitle="عنوان لاتین"
            rules=""
            :validation-container-class="largeColWidth"
            input-class="form-control"
            v-model="form.second_name"
          />

          <bita-treeselect
            name="category_id"
            ref="categoryTreeselect"
            label="گروه"
            rules="required"
            :validation-container-class="largeColWidth"
            input-class="form-control"
            :data-source="categories"
            data-text-field="name"
            data-value-field="id"
            v-model="form.category_id"
          />

          <bita-select
            name="designer_id"
            ref="designerSelect"
            rules="required"
            label="طراح"
            :validation-container-class="largeColWidth"
            input-class="form-control"
            :data-source="designers"
            data-text-field="full_name"
            data-value-field="id"
            v-model="form.designer_id"
          />

          <bita-input
              type="number"
              name="commission"
              label="پورسانت طراح"
              rules="required"
              :has-thousand-seprator="false"
              :validation-container-class="largeColWidth"
              input-class="form-control"
              v-model="form.commission"
          />

          <bita-select
            name="is_recommendation"
            ref="recommendedSelect"
            label="پیشنهاد لحظه ای"
            :validation-container-class="largeColWidth"
            input-class="form-control"
            :data-source="[
              { id: 0, name: 'خیر' },
              { id: 1, name: 'بله' },
            ]"
            data-text-field="name"
            data-value-field="id"
            v-model="form.is_recommended"
            :filter="'none'"
          />

          <bita-select
            name="active"
            ref="activeSelect"
            label="وضعیت"
            :validation-container-class="largeColWidth"
            input-class="form-control"
            :data-source="[
              { id: 0, name: 'غیر فعال' },
              { id: 1, name: 'فعال' },
            ]"
            data-text-field="name"
            data-value-field="id"
            v-model="form.active"
            :filter="'none'"
          />
          <!-- <bita-uploader
            name="uploader"
            label="تصویر راهنما"
            rules="size:50"
            ref="uploader"
            :validation-container-class="largeColWidth"
            input-class="form-control"
            v-model="form.help"
            :preview="true"
            :icon-url="form.help_file ? form.help_file.full_url : null"
          /> -->
          <!-- <bita-select
            v-if="accessCollection"
            name="collection_id"
            ref="collectionSelect"
            label="کالکشن"
            :validation-container-class="largeColWidth"
            input-class="form-control"
            :data-source="collections"
            data-text-field="title"
            data-value-field="id"
            v-model="form.collection_id"
          /> -->

          <bita-multiselect
            v-if="accessCollection"
            name="collections"
            ref="collectionSelect"
            label="سازندگان"
            :validation-container-class="largeColWidth"
            input-class="form-control"
            :data-source="collections"
            data-text-field="title"
            data-value-field="id"
            v-model="form.collections"
            validation-container-class="col-lg-12"
          />
          <bita-textarea
            name="short_description"
            ref="shortDescriptionTextarea"
            label="توضیح مختصر"
            rules=""
            validation-container-class="col-lg-12"
            input-class="form-control"
            v-model="form.short_description"
          />
          <bita-textarea
            name="short_description_2"
            ref="shortDescriptionTextarea"
            label="توضیح مختصر۲"
            rules=""
            validation-container-class="col-lg-12"
            input-class="form-control"
            v-model="form.short_description_2"
          />
          <bita-texteditor
            name="description"
            ref="descriptionTextarea"
            label="توضیح"
            rules=""
            validation-container-class="col-lg-12"
            input-class="form-control"
            v-model="form.description"
          />
        </div>
      </div>
    </bita-form>
  </div>
</template>
<script>
import {
  categoryApi,
  productApi,
  userApi,
  productCollectionApi,
} from "@/api/apiManagement";
export default {
  props: {
    title: String,
    isLoading: Boolean,
    largeColWidth: {
      default: "col-lg-3",
    },
    smallColWidth: {
      default: "col-lg-2",
    },
    product: {},
  },
  data() {
    return {
      form: {},
      categories: [],
      collections: [],
      designers: [],
    };
  },
  mounted() {
    var _this = this;
    Promise.all([
      categoryApi.getCategories(),
      userApi.getDesignerUsers([]),
    ]).then((res) => {
      this.categories = res[0].data.entity;
      this.designers = res[1].data.entity;
    });
    if (this.accessCollection)
      productCollectionApi.gets().then((res) => {
        this.collections = res.data.entity;
      });
  },
  watch: {
    product: function(_data) {
      this.form = _data;
      // this.$refs.shortDescriptionTextarea.setInitialValue(
      //   _data.short_description
      // );
      this.$refs.descriptionTextarea.setInitialValue(_data.description);
    },
  },
  computed: {
    formRef() {
      return this.$refs.form;
    },
    isUpdateMode() {
      return this.form.id && this.form.id > 0;
    },
    accessCollection() {
      return this.$acl.can("view", "product-collections");
    },
  },
  methods: {
    setInitialValue(_data) {
      this.form = _data;
      // this.$refs.descriptionTextarea.setInitialValue(
      //   _data.description ? _data.description : ""
      // );
    },

    save() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate().then((result) => {
          if (result) {
            this.$emit("is-loading", true);
            if (this.isUpdateMode) {
              productApi
                .updateProductInfo(this.form.id, this.$getFormData(this.form))
                .then((res) => {
                  this.$emit("on-update", this.form);
                  resolve(true);
                })
                .finally(() => {
                  this.$emit("is-loading", false);
                })
                .catch((err) => {
                  this.setErrors(err.response.data.errors);
                  reject(err);
                });
            } else {
              productApi
                .createProduct(this.$getFormData(this.form))
                .then((res) => {
                  this.form = res.data.entity;
                  this.$emit("on-update", this.form);
                  resolve(true);
                })
                .finally(() => {
                  this.$emit("is-loading", false);
                })
                .catch((err) => {
                  this.setErrors(err.response.data.errors);
                  reject(err);
                });
            }
          } else reject(false);
        });
      });
    },

    validate() {
      return this.$refs.form.validate();
    },

    setErrors(err) {
      this.$refs.form.setErrors(err);
    },

    reset() {
      this.form = {};
      this.$refs.categoryTreeselect.emptyKendo();
      this.$refs.recommendedSelect.emptyKendo();
      this.$refs.activeSelect.emptyKendo();
      // this.$refs.shortDescriptionTextarea.reset();
      this.$refs.descriptionTextarea.reset();
      this.$refs.collectionsSelect.emptyKendo();
      this.formRef.reset();
    },
  },
};
</script>
